import { type FC } from "react";
import { SelectBox } from "@root/shared/components/SelectBox";
import { useFormContext } from "react-hook-form";
import { Label } from "@root/shared/components/Label";
import { type InputMessageViewProps } from "@clientFrontend/features/entry/components/NotAdopted/type";
import * as styles from "./styles.css";

export const SpView: FC<InputMessageViewProps> = ({
  selectBoxOptions,
  mailBody,
  selectedMessageType,
}) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  return (
    <div className={styles.form}>
      <h3 className={styles.formItem}>
        メール内容
        <Label theme="lightPink" className={styles.formRequiredLabel}>
          必須
        </Label>
      </h3>
      <div className={styles.formContainer}>
        <SelectBox
          {...register("message", {
            required: "選択してください。",
          })}
          hasError={!!errors.message}
          selected={!!selectedMessageType}
          options={selectBoxOptions}
          placeholder="メールの内容を選択してください"
        />
        {errors.message && <p className={styles.errorMessage}>{errors.message.message}</p>}
        {!!selectedMessageType && mailBody}
      </div>
    </div>
  );
};
